/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ dag: NonNullable<unknown>, lesuur: NonNullable<unknown> }} Planning_Rooster_CelInputs */

const nl_planning_rooster_cel = /** @type {(inputs: Planning_Rooster_CelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dag} ${i?.lesuur}`)
};

/**

* @param {Planning_Rooster_CelInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_cel = /** @type {((inputs: Planning_Rooster_CelInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_CelInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_cel(inputs)
});
export { planning_rooster_cel as "planning.rooster.cel" }